<clr-progress-bar
  class="top"
  [clrValue]="progressPercentage"
></clr-progress-bar>
